/**
 * Returns a consistent Tailwind background color class for a given ID.
 * 
 * @param id - A unique, stable identifier for the user (e.g., userId or partnerPatientId)
 * @returns Tailwind background color class (e.g., 'bg-blue-500')
 */
export function getAvatarColorClass(id: string | number | undefined): string {

    const colors = [
      'bg-indigo-100',
      'bg-blue-100',
      'bg-cyan-100',
      'bg-teal-100',
      'bg-emerald-100',
      'bg-violet-100',
      'bg-purple-100',
      'bg-fuchsia-100',
      'bg-amber-100',
      'bg-rose-100',
    ];
  
    if (!id) {
      // Fallback color if no ID provided
      return 'bg-gray-100';
    }
  
    // Convert ID to string and hash it to a numeric index
    const str = id.toString();
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
      hash = hash & hash; // Force 32-bit integer
    }
  
    const index = Math.abs(hash) % colors.length;
    return colors[index];
}